import styled from 'styled-components';

const Button = styled.button`
  all: unset;
  cursor: pointer;
  display: inline-flex;
  border-radius: 6px;

  &:focus-visible {
    outline: 2px solid ${(props) => props.theme.colors.main_cta};
    outline-offset: 2px;
  }
`;

export default { Button };
